export function getCurrentUrl() {
	return window.location.pathname + window.location.search;
}

export function getCurrentQueryString() {
	return window.location.search;
}